import React from "react"

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_10214_4702)">
        <path
          d="M16.7176 7.79209C16.341 7.41551 15.7327 7.41551 15.3561 7.79209L12 11.1385L8.64388 7.78243C8.26731 7.40586 7.659 7.40586 7.28243 7.78243C6.90586 8.159 6.90586 8.76731 7.28243 9.14388L10.6385 12.5L7.28243 15.8561C6.90586 16.2327 6.90586 16.841 7.28243 17.2176C7.659 17.5941 8.26731 17.5941 8.64388 17.2176L12 13.8615L15.3561 17.2176C15.7327 17.5941 16.341 17.5941 16.7176 17.2176C17.0941 16.841 17.0941 16.2327 16.7176 15.8561L13.3615 12.5L16.7176 9.14388C17.0845 8.77697 17.0845 8.159 16.7176 7.79209Z"
          fill="#69757D"
        />
      </g>
      <defs>
        <clipPath id="clip0_10214_4702">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CloseIcon
